import { urlFor } from "../../../lib/sanity";
import { PortableText, toPlainText } from "@portabletext/react";
import Link from "next/link";
import { formatDate, trimText } from "../../../common/helper";

interface ArticleCardVerticalProps {
    post: {
        title: string;
        publishedAt: string;
        mainImage: string;
        body: string;
        slug: { current: string };
        categories: Array<{ slug: { current: string }; title: string }>;
        author: string;
    };
    hasText: boolean;
    readMore: boolean;
    size?: "big" | "small";
}

export default function ArticleCardVertical({
    post,
    hasText,
    size,
    readMore,
}: ArticleCardVerticalProps) {
    const { title, publishedAt, mainImage, body, categories, slug, author } =
        post;

    return (
        <div className="pt-8 flex flex-col items-start">
            <Link href="/blog/[slug]" as={`/blog/${slug.current}`}>
                <a className="w-full">
                    {mainImage && (
                        <div className="w-full">
                            <img
                                src={urlFor(mainImage)
                                    .size(
                                        size === "big" ? 1600 : 800,
                                        size === "big" ? 920 : 440
                                    )
                                    .fit("crop")
                                    .url()}
                                className="rounded w-full mb-2"
                            />
                        </div>
                    )}
                    <Link
                        href="/blog/kategorija/[slug]"
                        as={`/blog/kategorija/${categories[0].slug?.current}`}
                    >
                        <a>
                            <span className="inline-block  text-indigo-500 text-xs font-medium tracking-widest">
                                {categories && (
                                    <span className="uppercase">
                                        {categories[0].title}
                                    </span>
                                )}
                            </span>
                        </a>
                    </Link>
                    <h2
                        className={`${
                            size === "big"
                                ? "sm:text-3xl text-2xl"
                                : "sm:text-2xl text-xl"
                        } !leading-snug title-font font-medium text-gray-900 mt-2 mb-4`}
                    >
                        {title}
                    </h2>
                </a>
            </Link>
            {hasText && (
                <p className="leading-relaxed mb-8">
                    {body
                        ? trimText(toPlainText(body as any), 300) + "..."
                        : ""}
                </p>
            )}
            {readMore && (
                <div className="flex items-center flex-wrap pb-4mt-auto w-full">
                    {/* <span className="inline-flex items-center">
                    {publishedAt ? formatDate(publishedAt) : ""}
                </span> */}

                    <Link href="/blog/[slug]" as={`/blog/${slug.current}`}>
                        <a className="text-blue inline-flex items-center">
                            Saznaj više
                            <svg
                                className="w-4 h-4 ml-2"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                stroke-width="2"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                                <path d="M5 12h14"></path>
                                <path d="M12 5l7 7-7 7"></path>
                            </svg>
                        </a>
                    </Link>
                </div>
            )}
            {/* {author && (
                <Link
                    href="/blog/autor/[slug]"
                    as={`/blog/autor/${author.slug?.current}`}
                >
                    <a className="inline-flex items-center">
                        <img
                            alt="blog"
                            src={
                                author.image
                                    ? urlFor(author.image)
                                          .width(100)
                                          .height(100)
                                          .url()
                                    : ""
                            }
                            className="w-12 h-12 rounded-full flex-shrink-0 object-cover object-center"
                        />
                        <span className="flex-grow flex flex-col pl-4">
                            <span className="title-font font-medium text-gray-900">
                                <span>{author.name}</span>
                            </span>
                            <span className="text-gray-400 text-xs tracking-widest mt-0.5 uppercase">
                                {author.title}
                            </span>
                        </span>
                    </a>
                </Link>
            )} */}
        </div>
    );
}
